import Restaurant from '@components/restaurant/models/Restaurant';
import { Box, CardMedia } from '@mui/material';
import React from 'react';

interface RestaurantImageProps {
    restaurant: Restaurant;
}

const RestaurantImage: React.FC<RestaurantImageProps> = ({ restaurant }) => {
    return (
        <Box overflow={"hidden"} borderRadius={1}>
            <CardMedia
                id="restaurant-card-media"
                component="img"
                image={`${process.env.REACT_APP_RESTAURANT_IMAGES_URL}/${restaurant.id}.jpg`}
                alt={restaurant.name}
                title={restaurant.name}
                sx={(theme) => ({
                    height: 136,
                    [theme.breakpoints.up("sm")]: {
                        height: 146
                    },
                    borderRadius: 1,
                    transition: "transform .2s",
                })}
            />
        </Box>
    )
}

export default RestaurantImage;